<template>
  <transition mode="out-in" appear @enter="enter" @leave="leave" :css="false">
    <section class="index">
      <div class="index__bg">
        <div class="index__bg-view">
<!--          <video-->
<!--            id="indexEnterVideo"-->
<!--            src="https://vod.plaync.com/LineageW/01_intro_f_0810.mp4"-->
<!--            muted-->
<!--            playsinline-->
<!--          />-->
          <video
            id="indexLoopVideo"
            src="https://vod.plaync.com/LineageW/02_main_f.mp4"
            muted
            playsinline
            loop
            style="opacity: 0"
          />
<!--          <video-->
<!--            id="indexLeaveVideo"-->
<!--            src="https://vod.plaync.com/LineageW/01_intro_to_Book_f_0810.mp4"-->
<!--            muted-->
<!--            playsinline-->
<!--          />-->
        </div>
      </div>
      <FrameBook></FrameBook>
      <div class="index__contents">
        <div class="index__logo">
          Lineage W
          <div></div>
        </div>
        <div class="index__txt">
          <div class="index__txt-bg"></div>
          <div class="index__txt-bl">
            <span class="bl--1"></span><span class="bl--2"></span
            ><span class="bl--3"></span>
            <hr class="bl--r" />
            <hr class="bl--l" />
          </div>
          <div class="index__txt-tit" v-html="$t('index.tit')"></div>
          <hr class="index__txt-hr" />
          <div class="index__txt-desc" v-html="$t('index.desc')"></div>
          <!--
          <a :href="notice.link" class="index__notice">{{ notice.title }}</a>
          -->
        </div>
      </div>
      <!--
      <div class="index__movie-con">
        <button
          v-if="device === 'mobile'"
          class="index__movie-mobile-layer"
          @click="movieLayer"
        ></button>
        <button class="index__movie-close" @click="movieHide"></button>
        <button class="index__movie-layer" @click="movieLayer"></button>
      </div>
      -->
      <!--
      <div class="index__banner-wrap">
        <a
          :href="notice.link"
          class="index__banner-con"
        >
          {{ $t("menu.preqna") }}
        </a>
        <button class="index__banner-close" @click="bannerHide"></button>
      </div> -->
      <ScrollBtn></ScrollBtn>
    </section>
  </transition>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import BaseSection from "./mixins/BaseSection.js";
import gsap from "gsap";
import FrameBook from "@/components/FrameBook";
import ScrollBtn from "../components/ScrollBtn";
import promokit from "@/utils/promokit";

  export default {
    name: "index",
    components: {FrameBook, ScrollBtn},
    mixins: [BaseSection],
    data(){
      return{
        name:'index',
        bg:null,
        indexLoopVideo:null,
        indexLeaveVideo:null,
        titMotion:null,
        introSpeed:1,
        thumbPlayer:'',
        youtube: {
          ko: "xO-9J4hPQZA",
          en: "VerUzJXMWEU",
          ja: "UC6QDp4HJ78",
          zh: "ZBGlx2tqIzg",
        },
        device: promokit.util.getDevice(),
      }
    },
    computed: {
      ...mapState([
        'contentsData',
        'country',
        'lang'
      ]),
      ...mapGetters([
        'getPreorderURL'
      ]),
      notice(){
        const notice = {
          link:'/'+this.country.toLowerCase()+'/'+this.contentsData.notice.link,
          title:this.contentsData.notice.title
        }
        return notice
      }
    },
    methods:{
      setMotion(){
        if(this.currentPage != '')this.introSpeed = 3;
        this.enterMotion = new gsap.timeline({paused:true, onStart: ()=>{this.setIsMovePage(true)}});
        this.enterMotion
          .addLabel('start')
          .from(this.$el, 0.5, {ease:'power2.easeOut'})

        this.titMotion = new gsap.timeline({paused:true});
        this.titMotion
          .addLabel('start')
          .from(this.$el.querySelector(`.${this.name}__logo`), 0.5, {scale:1.2, autoAlpha:0, ease:'power4.easeOut'})
          .addLabel('title', '-=0.3')
          .fromTo(this.$el.querySelector(`.${this.name}__logo > div`), 1, {autoAlpha:1}, {autoAlpha:0, ease:'expo.easeInOut'},'start+=0.5')
          .fromTo(this.$el.querySelector(`.${this.name}__txt .bl--1`), 0.4,{autoAlpha:0, rotation:190}, { autoAlpha:1, rotation:0, ease:'expo.easeInOut'}, 'title')
          .fromTo(this.$el.querySelector(`.${this.name}__txt .bl--2`), 0.4,{autoAlpha:0, rotation:-190}, { autoAlpha:1, rotation:0, ease:'expo.easeInOut'}, 'title')
          .fromTo(this.$el.querySelector(`.${this.name}__txt .bl--3`), 0.4,{autoAlpha:0, scale:3}, { autoAlpha:1, scale:1, ease:'Back.easeOut'}, 'title')
          .fromTo(this.$el.querySelector(`.${this.name}__txt .bl--r`), 0.4,{autoAlpha:0, x:-30, y:-5}, { autoAlpha:1, x:0, y:0, ease:'expo.easeInOut'}, 'title+=0.2')
          .fromTo(this.$el.querySelector(`.${this.name}__txt .bl--l`), 0.4,{autoAlpha:0, x:30, y:-5}, { autoAlpha:1, x:0, y:0, ease:'expo.easeInOut'}, 'title+=0.2')
          .fromTo(this.$el.querySelector(`.${this.name}__txt-bg`), 0.4,{autoAlpha:0, y:-10}, { autoAlpha:1, y:0, ease:'expo.easeOut'}, 'title+=0.2')
          .fromTo(this.$el.querySelector(`.${this.name}__txt-tit`), 0.4,{autoAlpha:0, y:30}, { autoAlpha:1, y:0, ease:'expo.easeOut'}, 'title+=0.4')
          .fromTo(this.$el.querySelector(`.${this.name}__txt-desc`), 0.4,{autoAlpha:0, y:-30}, { autoAlpha:0.4, y:0, ease:'expo.easeOut'}, 'title+=0.6')
          .fromTo(this.$el.querySelector(`.${this.name}__txt-hr`), 0.5,{scaleX:0}, { scaleX:1, ease:'expo.easeOut'}, 'title+=0.6')
          .fromTo(this.$el.querySelector(`.${this.name}__notice`), 0.5,{autoAlpha:0}, { autoAlpha:1, ease:'expo.easeOut'}, 'title+=0.7')
          .fromTo(this.$el.querySelector(`.scroll-btn`), 0.5,{autoAlpha:0, y:30}, {autoAlpha:1, y:0, ease:'expo.easeOut'}, 'start+=1')
          //.fromTo(this.$el.querySelector(`.index__banner-wrap`), 0.5,{autoAlpha:0, y:200}, {autoAlpha:1, y:0, ease:'expo.easeOut'}, 'start+=1')
          //.fromTo(this.$el.querySelector(`.index__movie-con`), 0.5,{autoAlpha:0, y:200}, {autoAlpha:1, y:0, ease:'expo.easeOut'}, 'start+=1')
          //.call(this.moviePlay, [], 'start+=1')

      },
      /*
      moviePlay(){
        const parseRange = document.createRange();
        const parse = Range.prototype.createContextualFragment.bind(parseRange);
        const layerEle =
          `<div id="indexVideoLayer">
            <div id="videoPlayer"></div>

          </div>`
        document.querySelector('.index__movie-con').appendChild(parse(layerEle));

        this.thumbPlayer = promokit.youtube({
          el: "#indexVideoLayer",
          youtubeid: this.youtube[this.lang],
          controls:false,
          mute:true,
          loop:true
        });
        this.thumbPlayer.play();
      },
      movieLayer(){
        this.thumbPlayer.pause();
        const parseRange = document.createRange();
        const parse = Range.prototype.createContextualFragment.bind(parseRange);
        const layerEle =
          `<div id="videoLayer">
            <div id="videoPlayer2"></div>
          </div>`
        document.querySelector('body').appendChild(parse(layerEle));

        const player = promokit.youtube({
          el: "#videoPlayer2",
          youtubeid: this.youtube[this.lang],
          controls:true,
          mute:false

        });
        const layer = promokit.layer({
          el: '#videoLayer',
          render: true,
          autoplayVideo: player
        });
        layer.open();
        layer.on('closeend', () => {
          document.querySelector('.promokit-layer').remove();
          this.thumbPlayer.play();
        });
      },
      movieHide(){
        this.thumbPlayer.pause();
        const delEle = this.$el.querySelector('.index__movie-con')
        gsap.to(delEle, 0.3, {opacity:0, onComplete:()=>{
            delEle.remove()
          }})
      },
      */
      /*
      bannerHide() {
        const delEle = this.$el.querySelector(".index__banner-wrap");
        gsap.to(delEle, 0.3, {
          opacity: 0,
          onComplete: () => {
            delEle.remove();
          },
        });
      },*/
      leave(el, done){
        this.indexLoopVideo.loop = false;
        this.setIsMovePage(true)
        this.titMotion.timeScale(3);
        this.titMotion.reverse();
       // this.indexLeaveVideo.style.display = 'block';
        gsap.fromTo( this.indexLeaveVideo, 0.3, {opacity:0}, {opacity:1, onComplete:()=>{
            this.enterPage.start();
          done();
        }})
       // this.indexLeaveVideo.play();
       // this.indexLeaveVideo.addEventListener('ended', (event) => {
         // this.enterPage.start();
        //  setTimeout(done, 1000)
         // done();
       // });
      },
    },
    mounted() {
      this.setIsMovePage(false);
      this.indexLoopVideo = document.querySelector('#indexLoopVideo')
     // this.indexLeaveVideo = document.querySelector('#indexLeaveVideo')
     // this.indexEnterVideo = document.querySelector('#indexEnterVideo')

     // if (this.isMobile && this.introSpeed == 3) {
       // this.indexEnterVideo.remove();
        gsap.to(this.indexLoopVideo, 1, {
          opacity: 1, onComplete: () => {
            this.titMotion.play();

            this.setIsMovePage(false);
            this.setIsIntro(false);
          }
        })
        this.indexLoopVideo.play();

      //}
      // else {
      //   this.indexEnterVideo.playbackRate = this.introSpeed;
      //   this.indexEnterVideo.addEventListener('ended', (event) => {
      //     this.indexLoopVideo.play();
      //     gsap.to(this.indexLoopVideo, 0.2, {
      //       opacity: 1, onComplete: () => {
      //         this.indexEnterVideo.remove();
      //         this.titMotion.play();
      //       }
      //     })
      //
      //     this.setIsMovePage(false);
      //     this.setIsIntro(false);
      //   });
      //
      //   this.indexEnterVideo.play();
      // }

    }
}
</script>

<style lang="scss">
  .index {
    z-index: -1;
    &__bg{
      @include position($width:100%, $height:100%);
      overflow: hidden;
      &-view{
        @include position($position:absolute, $top:0, $left:0, $width:100%, $height:100%);
        video {
          min-width: 100% !important;;
          min-height: 100% !important;
          width: auto;
          height: auto;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          &#indexLeaveVideo {
            display: none;
          }
        }
      }
    }
    &__contents{
      @include position($position:absolute, $top:50%, $left:50%);
      width:100%;
      height:100%;
    }
    &__logo{
      @include position($position:absolute,  $width:820px, $height:270px, $top:50%, $left:50%);
      @include bg($bg: '../assets/img/index_logo.png', $cover:cover);
      @include hide-text;
      margin-top:-500px;
      div{
        @include position($position:absolute,  $width:100%, $height:100%, $top:0, $left:0);
        @include bg($bg: '../assets/img/index_logo_ef.png', $cover:cover);
      }
    }

    &__txt{
      @include position($position:absolute,  $width:100%, $height:563px, $top:50%, $left:50%);
      &-bg{
        @include position($position:absolute,  $width:100%, $height:100%, $top:0, $left:50%);
        @include bg($bg: '../assets/img/tit_bg.png', $position:50% 0);
      }
      margin-top:-95px;

      &-bl{
        @include position($position:absolute,  $width:100%, $height:34px, $top:157px, $left:50%);
        >span{
          display: block;
          @include position($position:absolute,  $width:34px, $height:34px, $top:0, $left:50%);
          @include bg($bg: '../assets/img/tit_icon_b.png');
          &:nth-child(1){background-position-x:0 }
          &:nth-child(2){background-position-x:-34px }
          &:nth-child(3){background-position-x:-68px }
        }
        >hr{
          border:none;
          @include position($position:absolute,  $width:96px, $height:14px, $top:2px, $left:50%);
          @include bg($bg: '../assets/img/tit_icon_l.png');
          margin-left:17px;
          &:last-child{
            @include bg($bg: '../assets/img/tit_icon_r.png');
            margin-left:-113px;
          }
        }
      }
      &-tit{
        @include position($position:absolute,  $width:800px, $height:129px, $top:198px, $left:50%);
        @include bg($bg: '../assets/img/ko/index_title.png', $cover:cover);
        
        @include hide-text;
        .en &{
          @include bg($bg: '../assets/img/en/index_title_en.png', $cover:cover);
          top: 191px;
        }
        .ja &{
          @include position($position:absolute,  $width:800px, $height:157px, $top:166px, $left:50%);
          @include bg($bg: '../assets/img/ja/index_title_ja.png', $cover:cover);
        }
        .zh &{
          @include position($position:absolute,  $width:800px, $height:157px, $top:166px, $left:50%);
          @include bg($bg: '../assets/img/zh/index_title_zh.png', $cover:cover);
        }
      }
      
      &-hr{
        //display: none;
        border:none;
        @include position($position:absolute,  $width:467px, $height:37px, $top:340px, $left:50%);
        @include bg($bg: '../assets/img/tit_line.png');
        /*
        .en &, .zh &, .ja &{
          top: 386px;
        }*/
      }
      &-desc{
        @include position($position:absolute,  $width:100%, $top:370px, $left:50%);
        font-size:19px;
        text-align: center;
        letter-spacing: -0.9px;
        line-height: 1.8em;
        opacity: 0.5;
        .zh &, .en &{
          letter-spacing: 0px;
        }
        /*
        .en &, .ja &, .zh & {
          top: 320px;}*/
      }
    }
    &__notice{
      @include position($position:absolute,  $width:100%, $top:462px, $left:50%);
      text-align: center;
      font-size:15px;
      color:#bdb6a6;
      &:hover {
        text-decoration: underline;
        color:#bdb6a6;
      }
      &:before{
        vertical-align: middle;
        display: inline-block;
        width:24px * 0.65;
        height:30px * 0.65;
        margin-right:10px;
        @include bg($bg: '../assets/img/icon_notice.png', $cover:cover);
        content: '';
      }
      .en &, .ja &, .zh & {
        top: 416px;
      }
    }
    &__btn-con{
      @include position($position:absolute,  $width:100%, $top:502px, $left:50%);
      text-align: center;
      .en &, .ja &, .zh & {
        top: 456px;
      }
    }
    &__btn{
      @include position($position:relative,  $width:230px, $height:86px);
      @include hide-text;
      display: inline-block;
      margin:0;
      .ko &{
        @include bg($bg: '../assets/img/ko/index_btn_ko_0917.png');
      }
      .en &{
        @include bg($bg: '../assets/img/en/index_btn_en_0917.png');
        background-position-y: -8px !important;
      }
      .ja &{
        @include bg($bg: '../assets/img/ja/index_btn_ja_0917.png');
      }
      .zh &{
        @include bg($bg: '../assets/img/zh/index_btn_zh_0917.png');
      }
      &:after{
        @include position($position:absolute,  $width:100%, $height:100%, $top:0, $left:0);
        content:'';
        opacity: 0;
        transition: 0.3s;
        background-position-y: -86px !important;
        .ko &{
          @include bg($bg: '../assets/img/ko/index_btn_ko_0917.png');
        }
        .en &{
          @include bg($bg: '../assets/img/en/index_btn_en_0917.png');
          background-position-y: -94px !important;
        }
        .ja &{
          @include bg($bg: '../assets/img/ja/index_btn_ja_0917.png');
        }
        .zh &{
          @include bg($bg: '../assets/img/zh/index_btn_zh_0917.png');
        }
      }

      &:hover{
        &:after{
          opacity: 1;
          transition: 0.3s;
        }
      }
      &--preorder{

        background-position-x: 0px!important;
        &:after{
          background-position-x: 0px!important;
        }
      }
      &--showcase{
        background-position-x: -459px !important;
        &:after{
          background-position-x: -459px !important;
        }
        .en &{
          width:230px;
          background-position-x: -459px !important;
          &:after{
            background-position-x: -459px !important;
          }
        }
      }
      &--qna{
        background-position-x: -420px !important;
        &:after{
          background-position-x: -420px !important;
        }
        .en &{
          width:230px;
          background-position-x: -458px !important;
          &:after{
            background-position-x: -458px !important;
          }
        }
      }
      &--precharacter{
        background-position-x: -229px !important;
        &:after{
          background-position-x: -229px !important;
        }
        .en &{
          width:230px;
          background-position-x: -229px !important;
          &:after{
            background-position-x: -229px !important;
          }
        }
      }
    }
    /*
    &__banner-wrap {
      @include position(
        $position: absolute,
        $width: 432px,
        $height: 240px,
        $bottom: 0,
        $right: 0
      );
      @include bg($bg: "../assets/img/ko/banner_coming_soon.jpg", $cover: cover);
      z-index: 10;
      .en & {
        @include bg($bg: "../assets/img/en/banner_coming_soon_en.png");
      }
      .ja & {
        @include bg($bg: "../assets/img/ja/banner_coming_soon_ja.png");
      }
      .zh & {
        @include bg($bg: "../assets/img/zh/banner_coming_soon_zh.png");
      }
    }
    &__banner-con {
      display: block;
      width: 100%;
      height: 100%;
      @include hide-text;
    }
    &__banner-close {
      @include position(
        $position: absolute,
        $width: 48px,
        $height: 48px,
        $top: 4px,
        $right: 4px
      );
      //@include bg($bg: "../assets/img/icon_video_x.png", $cover: cover);
      z-index: 11;
    }*/
    &__movie-con{
      @include position($position:absolute,  $width:426px, $height:240px, $bottom:0, $right:0);
      background: #000;
      z-index: 10;
      .promokit-youtube, .promokit-youtube__screen-wrap{
        width:426px;
        height:240px;
      }
      .promokit-youtube__bg{
        display: none;
      }
    }
    &__movie-mobile-layer{
      pointer-events: all;
      @include position($position:absolute,  $width:100%, $height:auto, $top:0px, $right:0px, $bottom: 0px, $left: 0px);
      z-index: 10;
    }
    &__movie-close{
      @include position($position:absolute,  $width:48px, $height:48px, $top:4px, $right:4px);
      @include bg($bg: '../assets/img/icon_video_x.png', $cover:cover);
      z-index: 11;
    }
    &__movie-layer{
      pointer-events: all;
      @include position($position:absolute,  $width:48px, $height:48px, $top:5px, $right:48px);
      @include bg($bg: '../assets/img/icon_video_y.png', $cover:cover);
      z-index: 11;
    }
    @include bp(tablet){
      &__bg{
        min-height: auto;
        &-view{
          video{
            height: 100%;
          }
        }
      }
      &__logo{
        @include position($position:absolute,  $width:820px*0.42, $height:270px*0.42, $top:40px, $left:50%);
        margin-top: 0;
      }
      &__txt {
        @include position($position: absolute, $width: 100%, $height: 563px/2, $top: 50%, $left: 50%);
        margin-top: -141px;

        &-bg {
          @include position($position: absolute, $width: 100%, $height: 100%, $top: 0, $left: 50%);
          @include bg($bg: '../assets/img/tit_bg.png', $position: 50% 0);
          background-size:360px auto;
          //display: none;
        }
        &-bl {
          top:47px;
          transform: scale(0.5);
        }
        &-tit{
          @include position($position:absolute,  $width:800px*0.45, $height:123px*0.45, $top:77px, $left:50%);
          .en &{
            @include position($position:absolute,  $width:800px*0.45, $height:192px*0.45, $top:75px, $left:50%);
            @include bg($bg: '../assets/img/en/index_title_en_m.png', $cover:cover);
          }
          .ja &{
            @include position($position:absolute,  $width:800px*0.45, $height:157px*0.45, $top:59px, $left:50%);
          }
          .zh &{
            @include position($position:absolute,  $width:800px*0.45, $height:157px*0.45, $top:59px, $left:50%);
          }
        }
        &-hr{
          @include position($position:absolute,  $width:200px, $height:20px, $top:140px, $left:50%);
          background-size: cover;
          
          .en & {
            top:170px;
          }/*
          .ja & {
            top: 185px;
          }
          .zh & {
            top: 163px;
          }*/
        }
        &-desc{
          top:158px;
          font-size:12px;
          text-align: center;
          letter-spacing: 0px;
          line-height: 1.8em;
          opacity: 0.5;
          
          .en &{
            top: 185px;
          }/*
          .ja &, .zh & {
            top: 129px;
          }*/
        }
        
        

      }
      &__notice{
        top:200px;
        font-size:12px;
        &:before{
          width:24px * 0.5;
          height:30px * 0.5;
          margin-right:5px;
        }
        .en &{
          top: 230px;
        }
        .ja & {
          top: 201px;
        }
        .zh & {
          top: 179px;
        }
      }
      &__btn-con{
        @include position($position:absolute,  $width:100%, $top:226px, $left:50%);
        text-align: center;
        .en & {
          top: 266px;
        }
        .ja & {
          top: 227px;
        }
        .zh & {
          top: 205px;
        }
      }
      &__btn{
        @include position($position:relative, $width:230px*0.5, $height:86px*0.5);
        background-size: 690px*0.5 auto;
        .en &{
          background-position-y: -2px !important;
        }
        &:after{
          display: none;
        }
        &--preorder{
          background-position-x: 0px !important;
          .en &{
            width:114px;
          }
        }
        &--showcase{
          background-position-x: -230px !important;
          .en &{
            width:115px;
            background-position-x: -229px !important;
            &:after{
              background-position-x: -229px !important;
            }
          }
        }
        &--qna{
          background-position-x: -210px !important;
          .en &{
            //width:115px;
            background-position-x: -229px !important;
            &:after{
              background-position-x: -229px !important;
            }
          }
        }
        &--precharacter{
          background-position-x: -115px !important;
          .en &{
            width:115px;
            background-position-x: -114px !important;
            &:after{
              background-position-x: -114px !important;
            }
          }
        }
      }
      /*
      &__banner-wrap {
        @include position(
          $position: absolute,
          $width: 156px,
          $height: 88px,
          $bottom: 0,
          $right: 0
        );
      }
      &__banner-close {
        @include position(
          $position: absolute,
          $width: 30px,
          $height: 30px,
          $top: 4px,
          $right: 4px
        );
      }*/
      &__movie-con{
        @include position($position:absolute,  $width:156px, $height:88px, $bottom:0, $right:0);
        .promokit-youtube, .promokit-youtube__screen-wrap{
          width:156px;
          height:88px;
        }
      }
      &__movie-close{
        @include position($position:absolute,  $width:30px, $height:30px, $top:4px, $right:4px);
      }
      &__movie-layer{
        display: none;
      }
      .br_mo{display: block;}
    }
    @include bp(mobile){
      &__movie-con{
        .promokit-youtube{
          min-width: auto;
          width:156px;
          height:88px;
        }
      }
      &__txt {
        top: auto;
        bottom: 91px;
        /*
        .en & {
          bottom: 131px;
        }*/
        /*
        .zh & {
          bottom: 69px;
        }*/
        bottom: 174px;
      }
    }
    @media (max-width: 960px) and (min-aspect-ratio: 1920/1080) {
      &__bg {
        &-view {
          video {
            width: 100%;
            height: auto;

          }
        }
      }
    }
  }

</style>
